    import { Component } from "react";
    // const API_URL = "http://localhost/raj_jwe_backend/api";
    import { API_BASE_URL } from '../config/app';
    class Contacthelper extends Component {
        reCaptchaLoaded = (value) => {
            console.log("Captcha token:", value);
        };
        
        constructor(props) {
            super(props);

            this.state = {
                name: "",
                email: "",
                phone: "",
                subject: "",
                message: "",
                loading: false,
            };
        }

        onNameChange = (e) => this.setState({ name: e.target.value });
        onEmailChange = (e) => this.setState({ email: e.target.value });
        onPhoneChange = (e) => this.setState({ phone: e.target.value });
        onSubjectChange = (e) => this.setState({ subject: e.target.value });
        onMessageChange = (e) => this.setState({ message: e.target.value });

        handleSubmit = async (e) => {
            e.preventDefault();

            this.setState({ loading: true });

            try {
                const response = await fetch(`${API_BASE_URL}/contact`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "X-Requested-With": "XMLHttpRequest",
                    },
                    body: JSON.stringify({
                        full_name: this.state.name,
                        email: this.state.email,
                        phone: this.state.phone,
                        subject: this.state.subject,
                        message: this.state.message,
                    }),
                });

                const rawText = await response.text();

                let result = {};
                if (rawText) {
                    try {
                        // remove BOM / invisible chars before parsing
                        const cleanText = rawText.replace(/^\uFEFF/, "").trim();
                        result = JSON.parse(cleanText);
                    } catch (parseError) {
                        console.warn("Non-JSON response from API:", rawText);
                    }
                }

                if (!response.ok) {
                    throw new Error(result.message || `HTTP ${response.status}`);
                }

                // ✅ SUCCESS
                document
                    .getElementById("server_response_success")
                    .classList.remove("d-none");

                document
                    .getElementById("server_response_danger")
                    .classList.add("d-none");

                this.setState({
                    name: "",
                    email: "",
                    phone: "",
                    subject: "",
                    message: "",
                });
            } catch (error) {
                console.error("Contact form error:", error);

                document
                    .getElementById("server_response_danger")
                    .classList.remove("d-none");
            } finally {
                this.setState({ loading: false });
            }
        };

    }

    export default Contacthelper;
